require('./bootstrap.min.js');
require('./plugins/imask.min.js');
require('./masks.js');
require('./global.js');

require('./validate.min.js');
require('./validatePlus.min.js');